module.exports = __webpack_public_path__ + "img/pic_australia_08.cb3fc76d.jpg";